import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogContentText ,DialogTitle, Button } from "@material-ui/core";
import { publishTemplate } from '../../services/whatsApp'
import {Alert, AlertTitle} from '@material-ui/lab'

export const PublishTemplateModal = (props) => {
  // const [template, setTemplate] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [error, setError] = React.useState(null)

  React.useEffect(() => {
    setLoading(false)
    // Survey
    //   .get({id: props.id, organizationId: props.organizationId})
    //   .then(templateResult => {
    //     console.log('templateResult', templateResult)
    //     setTemplate(templateResult)
    //     setLoading(false)
    //   })
  }, [props.template, props.organizationId])

  const onConfirm = function () {
    const {id} = props.template

    setError(null)
    setSaving(true)

    publishTemplate({id, organizationId: props.organizationId})
      .then(() => {
        setSaving(false)
        props.onClose({ success: true, template: props.template })
      })
      .catch(err => {
        setSaving(false)
        setError({message: 'Failed to publish template, please try again. If the issue persists, please contact an administrator.'})
        console.log('PublishTemplate.onConfirm.failed', err)
      })
  }

  const onClose = function () {
    props.onClose({})
  }

  if (loading) {
    return null
  }

  return (
    <Dialog open={props.open} aria-labelledby="Publish WhatsApp Template Modal">
      <DialogTitle>Are you sure you want to publish this template, {props.template.label}?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Publishing is an irreversible action. Once published, you cannot delete or make any further changes to this template.
        </DialogContentText>

        {
          error && (
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              {error.message}
            </Alert>
          )
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading || saving}>Cancel</Button>
        <Button onClick={onConfirm} color="primary" disabled={loading || saving}>Confirm</Button>
      </DialogActions>
    </Dialog>
  )
}